import React from 'react'

import MenuSection from '../MenuSection'

import { CREATED_OPTIONS } from '../../helpers/parse'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'

type CreatedDateFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const CreatedDateFilter: React.FC<CreatedDateFilterProps> = props => {
  const { state, handleChange } = useTaskFilters()

  return (
    <MenuSection
      title='Created Dates'
      options={CREATED_OPTIONS}
      value={state.createdValue}
      setValue={handleChange('createdValue')}
      unassignedOpt='All Created Dates'
      {...props}
    />
  )
}

export default CreatedDateFilter
